import React, { Component, ReactNode, ErrorInfo } from 'react';
import { ErrorMessage, ErrorMessageProps } from '../ErrorMessage/ErrorMessage';

interface Props {
  children?: ReactNode;
  errorMessageProps?: ErrorMessageProps;
}

interface State {
  hasError: boolean;
}

export class ErrorBoundary extends Component<Props, State> {
  public state: State = {
    hasError: false,
  };

  public static getDerivedStateFromError(_: Error): State {
    return { hasError: true };
  }

  public componentDidCatch(error: Error, errorInfo: ErrorInfo) {
    console.error('Uncaught error:', error, errorInfo);
  }

  public render() {
    if (!this.state.hasError) return this.props.children;

    if (!window.Jbhifi?.isProd) {
      return <ErrorMessage {...(this.props.errorMessageProps ?? {})} />;
    }

    return null;
  }
}
